import React, { useEffect } from 'react';

export interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonicalUrl?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  ogImage = '/og-image.png',
  canonicalUrl
}) => {
  useEffect(() => {
    const defaultTitle = 'Persatuan Seni Silat Awang Sulung Merah Muda Kedah (ASMM)';
    const siteTitle = title ? `${title} | PSSASMM Kedah` : defaultTitle;
    
    // Update Document Title
    document.title = siteTitle;

    // Helper function to safely set meta tags
    const setMetaTag = (selector: string, attrName: string, attrValue: string, content: string) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    const fullOgImage = ogImage.startsWith('http') ? ogImage : `${window.location.origin}${ogImage}`;
    const pageDescription = description || 'Portal Rasmi Persatuan Seni Silat Awang Sulung Merah Muda Negeri Kedah (ROS: PPM-007-02-28082022). Pusat latihan seni silat tradisi Melayu, pendaftaran gelanggang, silibus bengkung, dan direktori ahli.';

    // Meta Description & Keywords
    setMetaTag('meta[name="description"]', 'name', 'description', pageDescription);
    if (keywords) {
      setMetaTag('meta[name="keywords"]', 'name', 'keywords', keywords);
    }

    // Open Graph Meta Tags (Facebook, WhatsApp, Telegram, LinkedIn)
    setMetaTag('meta[property="og:title"]', 'property', 'og:title', siteTitle);
    setMetaTag('meta[property="og:description"]', 'property', 'og:description', pageDescription);
    setMetaTag('meta[property="og:image"]', 'property', 'og:image', fullOgImage);
    setMetaTag('meta[property="og:url"]', 'property', 'og:url', canonicalUrl || window.location.href);

    // Twitter Card Meta Tags
    setMetaTag('meta[property="twitter:title"]', 'property', 'twitter:title', siteTitle);
    setMetaTag('meta[property="twitter:description"]', 'property', 'twitter:description', pageDescription);
    setMetaTag('meta[property="twitter:image"]', 'property', 'twitter:image', fullOgImage);

    // Canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl || window.location.href);

  }, [title, description, keywords, ogImage, canonicalUrl]);

  return null;
};
